
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"Group 2107","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 120 180"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"data-name":"Rectangle 3303","width":"24","height":"120","rx":"12","transform":"translate(48 60)","fill":"#7469d9"}}),_c('path',{attrs:{"data-name":"Polygon 106","d":"M52.318 45.219a10 10 0 0115.364 0l38.65 46.381A10 10 0 0198.65 108h-77.3a10 10 0 01-7.682-16.4z","fill":"#7469d9"}}),_c('rect',{attrs:{"data-name":"Rectangle 3304","width":"120","height":"24","rx":"10","fill":"#7469d9"}})])
          )
        }
      }
    